import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CREDIT_PACKAGES } from '../../config/pricing.config';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  packages = CREDIT_PACKAGES;
  isLoading = false;
  isProcessing = false;
  errorMessage = '';
  selectedPackage: any = null;

  // Telegram contact for alternative payment methods
  telegramContact = 'https://t.me/quickindexingtool';

  constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.checkForSelectedPackage();
  }

  checkForSelectedPackage() {
    this.route.queryParams.subscribe(params => {
      if (params['package']) {
        try {
          const urlPackage = JSON.parse(params['package']);
          // Validate against predefined packages
          const isValid = CREDIT_PACKAGES.some(pkg =>
            pkg.credits === urlPackage.credits && pkg.price === urlPackage.price
          );

          if (isValid) {
            this.selectedPackage = urlPackage;
          } else {
            this.router.navigate(['/credits']);
          }
        } catch (error) {
          this.router.navigate(['/credits']);
        }
      }
    });
  }

  async payWithCrypto(packageData: any) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.isProcessing = true;
    this.errorMessage = '';

    try {
      const token = localStorage.getItem('auth_token');
      if (!token) {
        this.router.navigate(['/login']);
        return;
      }

      const data: any = await firstValueFrom(
        this.http.post(`${environment.apiUrl}/payment/nowpayments-create-invoice.php`, {
          custom_package: packageData
        }, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      );

      if (!data.success) {
        throw new Error(data.error || 'Failed to create crypto invoice');
      }

      // Redirect to NOWPayments hosted checkout
      window.location.href = data.data.invoice_url;

    } catch (error) {
      console.error('Payment error:', error);
      this.errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      this.isLoading = false;
      this.isProcessing = false;
    }
  }

  initiatePayment() {
    if (this.selectedPackage) {
      this.payWithCrypto(this.selectedPackage);
    }
  }

  openTelegram() {
    window.open(this.telegramContact, '_blank');
  }

  getDiscount(pkg: any): number {
    if (!pkg.original_price) return 0;
    return Math.round(((pkg.original_price - pkg.price) / pkg.original_price) * 100);
  }

  getPricePerCredit(pkg: any): string {
    if (!pkg || !pkg.credits || pkg.credits <= 0) return '0.00';
    return (pkg.price / pkg.credits).toFixed(2);
  }

  isPopular(pkg: any): boolean {
    return pkg.credits === 250;
  }
}